
riot.tag2('geotargeting-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Список городов</div>\n    </yield>\n    <yield to="body">\n      <catalog name="geotargeting" object="GeoTargeting" cols="{geoCols}" search="true" reload="false" disable-col-select="1" dblclick="{parent.opts.submit}" handlers="{handlers}">\n        <datatable-cell name="id">{row.id}</datatable-cell>\n        <datatable-cell name="name" onclick="{handlers.select}">{row.name}</datatable-cell>\n        <datatable-cell name="url" onclick="{handlers.select}">{row.url}</datatable-cell>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.tab = 'contacts';

    modal.tabClick = function (e) {
        modal.tab = e.item.name;
    };

    modal.handlers = {};

    modal.geoCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Город' }, { name: 'url', value: 'Домен' }];
});
});


// WEBPACK FOOTER //
// ./pages/settings/geotargeting/geotargeting-list-modal.tag